import React from "react";
import { PageLayout, Callout, PageLoading } from "../../ui";
import { useUsageData } from "./hooks/useUsageData";
import { UsageView } from "./components/UsageView";

export default function UsagePage() {
  const { usageData, errorMessage, isLoading } = useUsageData();

  if (isLoading) {
    return <PageLoading title="Usage & Billing" variant="cards" />;
  }

  if (!usageData) {
    return (
      <PageLayout>
        <div className="flex-1 p-8">
          <Callout className="border-destructive/30 bg-destructive/10 text-destructive">
            {errorMessage || "Failed to load usage data."}
          </Callout>
        </div>
      </PageLayout>
    );
  }

  return <UsageView usageData={usageData} errorMessage={errorMessage} />;
}

